import { Column, FCC, H3 } from "@dgs/core";
import { ReactNode } from "react";
import styled from "styled-components";

interface Props {
	title: ReactNode;
	error?: string;
}

const WrapperColumn = styled(Column)`
	padding: ${({ theme }) => theme.spacing(8)} 0;
`;

const Error = styled.p`
	color: ${({ theme }) => theme.colors.palette.danger.main.base};
	font-size: ${({ theme }) => theme.fonts.sizes.small};
`;

export const RelationListSection: FCC<Props> = ({ title, error, children }) => {
	return (
		<WrapperColumn>
			<H3>{title}</H3>
			{error && <Error>{error}</Error>}
			{children}
		</WrapperColumn>
	);
};

export const RelationListRow = styled.div`
	display: grid;
	grid-template-columns: 1fr max-content;
	align-items: center;
	gap: ${({ theme }) => theme.spacing(2)};
`;

export const TwoColumn = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	align-items: center;
	gap: ${({ theme }) => theme.spacing(2)};

	${({ theme }) => theme.breakpoints.tablet} {
		grid-template-columns: 1fr 1fr;
	}
`;
